
import { useQueryClient } from "react-query";
import { useParams } from "react-router-dom";

export function useGetLanguages() {
    let query = ['CC_Languages']
    const queryClient = useQueryClient();
    return queryClient.getQueryData(query);
}

export function useGetConfigSports(params) {
    const { mirs_competition, mirs_discipline } = params
    let query = ['ConfigSports', mirs_competition, mirs_discipline]
    const queryClient = useQueryClient();
    return queryClient.getQueryData(query);
}

export function useGetConfigCompetitions(mirs_competition) {
    let query = ['ConfigCompetitions', mirs_competition]
    const queryClient = useQueryClient();
    return queryClient.getQueryData(query);
}

export function useGetCompetitions(params) {
    const { mirs_language } = params
    let query = ['CC_Competitions', mirs_language?.toUpperCase()]
    const queryClient = useQueryClient();
    return queryClient.getQueryData(query);
}

export function useGetDisciplines(params) {
    const { mirs_competition, mirs_language } = params
    let query = ['CC_Disciplines', mirs_competition, mirs_language?.toUpperCase()]
    const queryClient = useQueryClient();
    return queryClient.getQueryData(query);
}

export function useGetEventUnits(params) {
    const { mirs_competition, mirs_discipline, mirs_language } = params
    let query = ['CC_EventUnits', mirs_competition, mirs_discipline, mirs_language?.toUpperCase()]
    const queryClient = useQueryClient();
    return queryClient.getQueryData(query);
}

export function useGetPositions(params) {
    const { mirs_competition, mirs_discipline, mirs_language } = params
    let query = ['CC_Positions', mirs_competition, mirs_discipline, mirs_language?.toUpperCase()]
    const queryClient = useQueryClient();
    return queryClient.getQueryData(query);
}

export function useGetRoutes(mlanguage) {
    const { mirs_language } = useParams()
    const queryClientRouter = useQueryClient();

    if (!mirs_language || mirs_language.length > 2) { return (null) }

    const language = mlanguage || mirs_language
    let router_language = language;
    let queryRouter = ['routerPaths', { router_language }]

    return queryClientRouter.getQueryData(queryRouter);

}

export function useGetFunctionRoutes() {
    const queryClientRouter = useQueryClient();
    return function (mlanguage) {
        let router_language = mlanguage;
        let queryRouter = ['routerPaths', { router_language }]

        return queryClientRouter.getQueryData(queryRouter);

    }

}

export function useGetNocs(params) {
    const { mirs_competition, mirs_language } = params
    let query = ['CC_Nocs', mirs_competition, mirs_language?.toUpperCase()]
    const queryClient = useQueryClient();
    return queryClient.getQueryData(query);
}